export enum FeatureFlags {
  NativeSimulator = 'NATIVE-SIMULATOR',
  PropertiesMenu = 'ENI-889',
  AskAI = 'ENI-978',
}
